import { render, staticRenderFns } from "./NoBindingStore.vue?vue&type=template&id=c5e565e8&scoped=true"
import script from "./NoBindingStore.vue?vue&type=script&lang=js"
export * from "./NoBindingStore.vue?vue&type=script&lang=js"
import style0 from "./NoBindingStore.vue?vue&type=style&index=0&id=c5e565e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e565e8",
  null
  
)

export default component.exports